import { format, parseISO } from 'date-fns';

export const fmt = {
  currency: (v: string | number | null | undefined, decimals = 2): string => {
    if (v == null || v === '') return '—';
    const n = Number(v);
    if (isNaN(n)) return '—';
    return `$${n.toFixed(decimals)}`;
  },

  percent: (v: string | number | null | undefined, decimals = 1): string => {
    if (v == null || v === '') return '—';
    const n = Number(v);
    if (isNaN(n)) return '—';
    return `${n.toFixed(decimals)}%`;
  },

  iv: (v: string | number | null | undefined): string => {
    if (v == null || v === '') return '—';
    const n = Number(v) * 100;
    if (isNaN(n)) return '—';
    return `${n.toFixed(1)}%`;
  },

  delta: (v: string | number | null | undefined): string => {
    if (v == null || v === '') return '—';
    const n = Math.abs(Number(v));
    if (isNaN(n)) return '—';
    return n.toFixed(2);
  },

  date: (v: string | null | undefined): string => {
    if (!v) return '—';
    try {
      return format(parseISO(v), 'MMM d, yyyy');
    } catch {
      return v;
    }
  },

  shortDate: (v: string | null | undefined): string => {
    if (!v) return '—';
    try {
      return format(parseISO(v), 'MMM d');
    } catch {
      return v;
    }
  },

  dateTime: (v: string | null | undefined): string => {
    if (!v) return '—';
    try {
      return format(parseISO(v), 'MMM d, h:mm a');
    } catch {
      return v;
    }
  },

  strike: (v: string | number | null | undefined): string => {
    if (v == null || v === '') return '—';
    const n = Number(v);
    if (isNaN(n)) return '—';
    return `$${n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)}`;
  },
};

export const gradeColor = (grade: string | null | undefined): string => {
  switch (grade) {
    case 'A+': return '#1b5e20';
    case 'A': return '#2e7d32';
    case 'B': return '#1565c0';
    case 'S': return '#757575';
    default: return '#757575';
  }
};

export const tierLabel = (tier: number | null | undefined): string => {
  switch (tier) {
    case 1: return 'Tier 1';
    case 2: return 'Tier 2';
    case 3: return 'Tier 3';
    default: return '—';
  }
};
